<template>
    <div id="consulting">
        <div class="page-inner-wrapper position-relative white-bg">
            <div class="position-relative page-header bg-img-atr-fix ">
                <div class="position-absolute overlay overlay-bg-lightdark">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <h1 class="white-color" v-scrollanimation>{{dataText.title}}</h1>
                    </div>
                </div>
            </div>
            <div class="container-fluid module-space">
                <div class="col-sm-12 module-space position-relative" style=" padding-top: 0;">
                    <div class="column-inner">
                        <div class="wrapper">
                            <div class="module-text-container p-text text-justify">
                                <p v-scrollanimation>{{dataText.p1}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-display module-space">
                    <div class="d-table chess-table">
                        <div class="d-table-cell text-cell left" v-scrollanimation>
                            <div class="module-text-container p-text text-justify">
                                <p>{{dataText.t1}}</p>
                            </div>
                        </div>
                        <div class="d-table-cell icon-cell position-relative">
                            <div class="module-icon-container position-absolute">
                                <div class="horizontal-divider black-bg horizontal-divider-first-child position-absolute" v-scrollanimation></div>
                                <div class="white-bg position-absolute icon-inner-container text-center trans-500-ms">
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-briefcase-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z"/>
                                        <path fill-rule="evenodd" d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5v1.384l-7.614 2.03a1.5 1.5 0 0 1-.772 0L0 5.884V4.5zm5-2A1.5 1.5 0 0 1 6.5 1h3A1.5 1.5 0 0 1 11 2.5V3h-1v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V3H5v-.5z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-table chess-table">
                        <div class="d-table-cell text-cell left" v-scrollanimation>
                            <div class="spacer-lg"></div>
                            <div class="module-text-container p-text text-justify">
                                <p>{{dataText.t2}}</p>
                            </div>
                        </div>
                        <div class="d-table-cell icon-cell position-relative">
                            <div class="module-icon-container position-absolute">
                                <div class="horizontal-divider black-bg" v-scrollanimation></div>
                                <div class="white-bg position-absolute icon-inner-container text-center trans-500-ms">
                                    <svg class="svg-key" width="2em" height="2em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" xml:space="preserve">
                                        <g>
                                            <path d="M334.974,0c-95.419,0-173.049,77.63-173.049,173.049c0,21.213,3.769,41.827,11.211,61.403L7.672,399.928
                                                    c-2.365,2.366-3.694,5.573-3.694,8.917v90.544c0,6.965,5.646,12.611,12.611,12.611h74.616c3.341,0,6.545-1.325,8.91-3.686
                                                    l25.145-25.107c2.37-2.366,3.701-5.577,3.701-8.925v-30.876h30.837c6.965,0,12.611-5.646,12.611-12.611v-12.36h12.361
                                                    c6.964,0,12.611-5.646,12.611-12.611v-27.136h27.136c3.344,0,6.551-1.329,8.917-3.694l40.121-40.121
                                                    c19.579,7.449,40.196,11.223,61.417,11.223c95.419,0,173.049-77.63,173.049-173.049C508.022,77.63,430.393,0,334.974,0z
                                                     M334.974,320.874c-20.642,0-40.606-4.169-59.339-12.393c-4.844-2.126-10.299-0.956-13.871,2.525
                                                    c-0.039,0.037-0.077,0.067-0.115,0.106l-42.354,42.354h-34.523c-6.965,0-12.611,5.646-12.611,12.611v27.136H159.8
                                                    c-6.964,0-12.611,5.646-12.611,12.611v12.36h-30.838c-6.964,0-12.611,5.646-12.611,12.611v38.257l-17.753,17.725H29.202v-17.821
                                                    l154.141-154.14c4.433-4.433,4.433-11.619,0-16.051s-11.617-4.434-16.053,0L29.202,436.854V414.07l167.696-167.708
                                                    c0.038-0.038,0.067-0.073,0.102-0.11c3.482-3.569,4.656-9.024,2.53-13.872c-8.216-18.732-12.38-38.695-12.38-59.33
                                                    c0-81.512,66.315-147.827,147.827-147.827S482.802,91.537,482.802,173.05C482.8,254.56,416.484,320.874,334.974,320.874z"/>
                                        </g>
                                        <g>
                                            <path d="M387.638,73.144c-26.047,0-47.237,21.19-47.237,47.237s21.19,47.237,47.237,47.237s47.237-21.19,47.237-47.237
                                                    S413.686,73.144,387.638,73.144z M387.638,142.396c-12.139,0-22.015-9.876-22.015-22.015s9.876-22.015,22.015-22.015
                                                    s22.015,9.876,22.015,22.015S399.777,142.396,387.638,142.396z"/>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-table chess-table">
                        <div class="d-table-cell text-cell left" v-scrollanimation>
                            <div class="spacer-lg"></div>
                            <div class="module-text-container p-text text-justify">
                                <p>{{dataText.t3}}</p>
                            </div>
                        </div>
                        <div class="d-table-cell icon-cell position-relative">
                            <div class="module-icon-container position-absolute">
                                <div class="horizontal-divider black-bg" v-scrollanimation></div>
                                <div class="white-bg position-absolute icon-inner-container text-center trans-500-ms">
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-bar-chart-line" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5h-2v12h2V2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"/>
                                        <path fill-rule="evenodd" d="M0 14.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-table chess-table">
                        <div class="d-table-cell text-cell left" v-scrollanimation>
                            <div class="spacer-lg"></div>
                            <div class="module-text-container p-text text-justify">
                                <p>{{dataText.t4}}</p>
                            </div>
                        </div>
                        <div class="d-table-cell icon-cell position-relative">
                            <div class="module-icon-container position-absolute">
                                <div class="horizontal-divider black-bg horizontal-divider-last-child" v-scrollanimation></div>
                                <div class="white-bg position-absolute icon-inner-container text-center trans-500-ms">
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-suit-heart" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M8 6.236l.894-1.789c.222-.443.607-1.08 1.152-1.595C10.582 2.345 11.224 2 12 2c1.676 0 3 1.326 3 2.92 0 1.211-.554 2.066-1.868 3.37-.337.334-.721.695-1.146 1.093C10.878 10.423 9.5 11.717 8 13.447c-1.5-1.73-2.878-3.024-3.986-4.064-.425-.398-.81-.76-1.146-1.093C1.554 6.986 1 6.131 1 4.92 1 3.326 2.324 2 4 2c.776 0 1.418.345 1.954.852.545.515.93 1.152 1.152 1.595L8 6.236zm.392 8.292a.513.513 0 0 1-.784 0c-1.601-1.902-3.05-3.262-4.243-4.381C1.3 8.208 0 6.989 0 4.92 0 2.755 1.79 1 4 1c1.6 0 2.719 1.05 3.404 2.008.26.365.458.716.596.992a7.55 7.55 0 0 1 .596-.992C9.281 2.049 10.4 1 12 1c2.21 0 4 1.755 4 3.92 0 2.069-1.3 3.288-3.365 5.227-1.193 1.12-2.642 2.48-4.243 4.38z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "../components/Footer";

    export default {
        name: "Consulting",
        props: {
            webData: {
                type: Object,
                required: true
            }
        },
        components: {Footer},
        data () {
            return {
                dataText: this.webData.services.consulting
            }
        },
        created () {
            if (window.innerWidth < 1150) {
                this.mobaDev = true;
                this.$store.state.mobaDev = true;
            } else  this.$store.state.mobaDev = false;
        },
    }
</script>

<style scoped>
    #consulting .page-header {
        background-image: url("../assets/photos/h3_consulting_header_bg.jpg");
    }
    #consulting .page-header .overlay .d-flex {
        height: 100%;
    }
    .module-icon-container {
        top: 0;
        bottom: 0;
        right: 0;
        padding: 0;
        width: 100%;
    }
    .icon-inner-container {
        padding: 10px 0;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .icon-inner-container svg {
        color: #0C0C0C;
    }
    .icon-inner-container svg:hover {
        color: #5666AE;
    }
    .horizontal-divider {
        margin: 0 auto;
        width: 3px;
        height: 100%;
    }
    .horizontal-divider-first-child {
        bottom: 0;
        left: 49.8%;
    }
    .horizontal-divider-last-child, .horizontal-divider-first-child {
        height: 50%;
    }
    .svg-key {
        transform: rotate3d(1, 1, 0, 180deg);
    }

</style>